import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const getShared = (shareId) => {
  const params = { shareId };
  return swRequest({
    path: "/api/shared/get",
    method: "GET",
    params,
  });
};

export const createSharedLink = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/shared/create",
      method: "POST",
      body,
    },
    opts,
  );
